import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

// Bar graph
const BarGraph = ({ data, title, format, yAxisType }) => {
  const yAxisFormatter = (val) => {
    if (yAxisType === "time") {
      const sign = val < 0 ? "-" : "";
      const abs = Math.abs(val);

      const h = Math.floor(abs / 3600);
      const m = Math.floor((abs % 3600) / 60);
      const s = Math.floor(abs % 60);

      return sign + [h, m, s].map(n => n.toString().padStart(2, "0")).join(":");
    }

    // default case — prefix + value
    // Optional: add number formatting (toLocaleString, fixed decimals, etc.)
    return format + val;
  };


  const [chartData, setChartData] = useState({
    series: [
      {
        name: title,
        data: [],
      },
    ],
    options: {
      chart: {
        height: 250,
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
        // formatter: function (val) {
        //   return format + val;
        // },
        formatter: yAxisFormatter,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
          // formatter: function (val) {
          //   return format + val;
          // },
          formatter: yAxisFormatter
        },
      },
      title: {
        text: title,
        align: "center",
        style: {
          color: "#444",
        },
      },
    },
  });

  // set the values for bar graph based on props
  useEffect(() => {
    if (data?.recordcounts && data?.dates) {
      setChartData((prevGraphData) => ({
        ...prevGraphData,
        series: [
          {
            ...prevGraphData.series[0],
            data: data?.recordcounts,
            // update on title change
            name: title
          },
        ],
        options: {
          ...prevGraphData.options,
          title: {
            ...prevGraphData.options.title,
            // Update chart title
            text: title,
          },
          xaxis: {
            ...prevGraphData.options.xaxis,
            categories: data?.dates?.map((month) => month.slice(0, 3)),
          },
        },
      }));
    }
  }, [data, title, format]);

  return (
    <ReactApexChart
      options={chartData.options}
      series={chartData.series}
      type="bar"
      height={250}
    />
  );
};

export default BarGraph;
